// 參數說明
// pathName = 當下完整路由
// routesWithPermission = 有權限控管的特定路由名稱陣列
// userPermissions = 特定路由的使用者權限(需對應陣列位置，下同)
// permissionLevelSettings = 特定路由的允許權限設定

// ex:
// permissionVerifier({
//   pathName: this.props.location.pathname,
//   routesWithPermission: ['admin', 'report'],
//   userPermissions:[0, 1],
//   permissionLevelSettings: [1, 1]
// })

const
  routesWithPermission =
    [
      'admin', 'news', 'product', 'online-repair-service', 'form-quotation',
      'form-cost', 'form-margin', 'form-order', 'form-goods', 'form-lading',
      'form-invoice', 'form-warehouse', 'calendar', 'work-log', 'customer',
      'sales-cases', 'shipping-records', 'km', 'parts-base', 'media-cloud',
      'report'
    ],
  permissionLevelSettings =
    [
      '1', true, true, true, true,
      true, true, true, true, true,
      true, true, true, true, true,
      true, true, true, true, true,
      true
    ];


export default function (pathName, userPermissions) {
  const len = routesWithPermission.length;
  // userPermissions 有3個地方會用到，這裡、LoggedInChecker、SideBarGroupCt
  // 應該整合成在一個地方維護就好
  if (!userPermissions) {
    const permissions = JSON.parse(sessionStorage.userPermission);

    userPermissions = [
      sessionStorage.isAdmin,
      // 最新消息 
      permissions.salesky_news_web === '3',
      // 產品資訊
      permissions.salesky_product_web === '3' ||
      permissions.salesky_products_web === '3',
      // 服務單
      location.hostname === 'localhost' ||
      permissions.salesky_repair_web * 1 > 1 ||
      permissions.servicesky_repair_web * 1 > 1,
      // 估價單
      permissions.salesky_quotation_web === '3',
      // 成本分析表
      permissions.salesky_cost_web === '3',
      // 保證金申請單
      permissions.salesky_margin_web === '3',
      // 訂單
      permissions.salesky_order_web === '3',
      // 貨品申購書
      permissions.salesky_goods_web === '3',
      // 領貨單
      permissions.salesky_lading_web === '3',
      // 發票申請單
      permissions.salesky_invoice_web === '3',
      // 入庫單
      permissions.salesky_warehouse_web === '3',
      // 該專案用不到的權限
      permissions.salesky_calendar_web === '3',
      permissions.salesky_worklog_web === '3',
      permissions.salesky_customers_web === '3',
      permissions.salesky_sales_case_web === '3',
      permissions.servicesky_delivery_order_web === '3',
      permissions.servicesky_km_web === '3',
      permissions.servicesky_part_web === '3',
      permissions.salesky_media_cloud_web === '3',
      permissions.salesky_report_web === '3'
    ];

  }

  for (let i = 0; i < len; i++) {
    if (pathName.indexOf(routesWithPermission[i]) !== -1) {
      if (userPermissions[i] !== permissionLevelSettings[i]) return false;
      break;
    }
  }

  return true;
}


// WEBPACK FOOTER //
// ./src/commonJS/permissionVerifier.js